import React from 'react'
import { Partner } from '../../../types'
import Template from '../../Meta/Template'

const PartnerMeta = ({ partner }: { partner: Partner }) => {
  const {
    brandName,
    description,
    favicons,
    googleVerification,
    imageUrl,
    landingPageTitle,
    twitterHandle,
    websiteUrl
  } = partner?.config?.head?.meta || {}
  const title = landingPageTitle || `${brandName}`

  return (
    <Template
      brandUrl={websiteUrl}
      description={description}
      favicons={favicons}
      googleVerification={googleVerification}
      imageUrl={imageUrl}
      title={title}
      twitterHandle={twitterHandle}
    />
  )
}

export default PartnerMeta
